import React from 'react';
var Tooltip = function (_a) {
    var text = _a.text, children = _a.children;
    return (React.createElement("div", { className: "group relative flex justify-center" },
        children,
        React.createElement("span", { className: "absolute top-6 hidden rounded bg-gray-800 p-2 text-xs text-white group-hover:block" }, text)));
};
export default Tooltip;
